module.exports = __webpack_public_path__ + "static/media/apple_black.cf191bcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/medias/apple_black.svg
// module id = 155
// module chunks = 0